import React, { useState } from "react";
import Drawer from "react-modern-drawer";
import "./index.scss";
import { ReactComponent as CloseIcon } from "../../../assets/images/icons/close-icon.svg";
import Form from "react-bootstrap/Form";
import { Close } from "@mui/icons-material";

const TicketTypeDrawer = (props) => {
  const { ticketTypes, handleSeatSelection, seat, handleApplyToAllSeats, applyToAllSeats, selectedSofaSeatGroupName, show, allowSingleSeatSelection, isOpen, onClose } = props;

  const [voucherNote, setVoucherNote] = useState(window.constant.TICKET_TYPE_NOTE);

  const ticketTypesLayout = window.constant.TICKET_TYPE_LAYOUT;

  const getSelectedSofaSeat = (seat) => {
    // console.log(seat, "seat", selectedSofaSeatGroupName, "selectedSofaSeatGroupName");
    if (seat.style.toLowerCase() !== "sofa") return;
    let seatGroup = seat.group.filter((seat) => seat.name === selectedSofaSeatGroupName)[0];
    // console.log(seatGroup, "seatGroup");
    return seatGroup;
  };

  const getTooltipTarget = () => {
    if (seat.style.toLowerCase() !== "sofa") {
      return document.getElementById(seat.name);
    } else {
      if (allowSingleSeatSelection === false) {
        return document.getElementById(seat.name);
      } else {
        return document.getElementById(getSelectedSofaSeat(seat)?.name);
      }
    }
  };

  const singleSeatAllowed = allowSingleSeatSelection.find((sofaSeat) => sofaSeat.area === seat.area)?.isAllowed;
  return (
    <Drawer open={isOpen} onClose={onClose} direction="bottom" className={`ticket-type-drawer ${isOpen ? "" : "is-hidden"}`}>
      <div className="ticket-type-content">
        <button className="close-btn" onClick={onClose}>
          <CloseIcon />
          {/* <img src={CloseIcon} alt="close" onClick={onClose} /> */}
        </button>
        {/* <h3 className="title">who's sitting in {singleSeatAllowed ? (seat.style.toLowerCase() === "sofa" ? getSelectedSofaSeat(seat)?.name : seat.name) : seat.name}?</h3> */}
        <h3 className="title">Select the Ticket for Seat {singleSeatAllowed ? (seat.style.toLowerCase() === "sofa" ? getSelectedSofaSeat(seat)?.name : seat.name) : seat.name}</h3>
        <div className={`ticket-type-btn-container ${ticketTypesLayout === "vertical" ? "is-vertical" : "is-horizontal"}`}>
          {ticketTypes &&
            ticketTypes.map((ticketType, ticketTypeIndex) => {
              if (ticketType.area !== seat.area) return null;
              return (
                <button
                  className={`ticket-type-btn`}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleSeatSelection(seat, ticketType, getSelectedSofaSeat(seat)?.id);
                  }}
                  disabled={ticketType?.disableTicketType}
                >
                  <span className="ticket-type-desc">{ticketType.description}&nbsp;-&nbsp;</span>
                  <span className="ticket-type-price">${ticketType.valueBeforeTax.toFixed(2)}</span>
                  {ticketType.hasOwnProperty("voucherCode") && (
                    <span className="ticketType-voucherCode">
                      {ticketType.voucherCode}
                      {`${ticketType.minQty > 0
                        ? ticketType.totalSeatsSelected && ticketType.totalSeatsSelected > 0
                          ? ` | ${ticketType.totalSeatsSelected} of ${ticketType.minQty} used`
                          : ` | ${ticketType.minQty} Available`
                        : ""
                        }`}
                    </span>
                  )}
                </button>
              );
            })}
        </div>
        {window.constant.TICKET_TYPE_NOTE_SHOW === "true"
          ? voucherNote &&
          voucherNote.length > 0 && (
            <p className="note">
              <span>NOTE: </span>
              {voucherNote}
            </p>
          )
          : ""}

        <div className="drawer-footer">
          {/* <FormControlLabel
                        onChange={handleApplyToAllSeats}
                        control={
                            <Checkbox
                                checked={applyToAllSeats}
                                size="small"
                                icon={CheckBoxIcon}
                                checkedIcon={CheckIcon}
                            />
                        }
                        label="Apply to all seats" /> */}
          <Form>
            <Form.Check type="checkbox" id="applyToAllSeats" label="Apply to all seats" checked={applyToAllSeats} onChange={handleApplyToAllSeats} className="apply-to-all-seats-checkbox" />
          </Form>
          {/* <button className="custom-button">
                        continue
                    </button> */}
        </div>
      </div>
    </Drawer>
  );
};

export default TicketTypeDrawer;
